// extracted by mini-css-extract-plugin
export default {"questionScalesList":"cardScoreActivityPost_questionScalesList__6q8aA"};